import { JwtToken } from "@sky/xerxes-client-react";
import { UserType, ListUsersCommand, AdminGetUserCommand, AttributeType, AdminGetUserCommandOutput } from "@aws-sdk/client-cognito-identity-provider";
import { AwsResponse, User } from "../model";
import { COGNITO } from '../config';
import AwsService from "./AwsService";

export default class UserService extends AwsService {

    public constructor(token: JwtToken) {
        super(token);
    }

    public fetchAll = async (pagination?: string): Promise<AwsResponse<User>> => {
        const command = new ListUsersCommand({ UserPoolId: COGNITO.userPoolId, Limit: 50, PaginationToken: pagination });
        const response = await this.cognitoClient.send(command);
        
        return {
            paginationToken: response.PaginationToken,
            results: (response.Users?.map(this.toUser) || []) as User[]
        }
    }

    public fetch = async (username: string): Promise<User> => {
        const command = new AdminGetUserCommand({ UserPoolId: COGNITO.userPoolId, Username: username });
        const response = await this.cognitoClient.send(command);

        return Promise.resolve(this.toUser(response));
    }

    public async delete(): Promise<void> {
        return Promise.resolve();
    }

    private toUser = (user: UserType | AdminGetUserCommandOutput): User => {
        let attributes: Record<string, any> = {};
        if ('Attributes' in user) {                 // UserType
            attributes = this.getAttributesAsObject(user.Attributes)
        } else if ('UserAttributes' in user) {      // AdminGetUserCommandOutput
            attributes = this.getAttributesAsObject(user.UserAttributes)
        }

        return {
            sub: attributes['sub'],
            username: user.Username,
            forename: attributes['given_name'],
            surname: attributes['family_name'],
            email: attributes['email'],
        } as User;
    }

    private getAttributesAsObject = (attributes: AttributeType[] | undefined): Record<string, any> => {
        return attributes?.reduce((prev, current) => (current.Name) ? {...prev, [current.Name]: current.Value  } : prev, {}) || {};
    }

}

